import axios from 'axios';

const recimetApi = axios.create({
  baseURL: 'https://back.gruporecimet.com.ar/api/', // recimet
  // baseURL: 'http://192.168.100.20:3001/api/'  // local
});

export default recimetApi;
